import React from 'react';
import { useIntl } from 'react-intl';
import { TabContent, TabPane } from "reactstrap";
import MetricsLineChart from "./charts/MetricsLineChart";
// Chart settings
var CHART_OPTIONS_DEFAULT = {
    elements: {
        line: {
            tension: 0
        }
    },
    animation: false,
    transitions: { active: { animation: { duration: 0 } } },
    scales: {
        type: 'time',
        xAxes: [{
                scaleLabel: {
                    display: true,
                    labelString: ''
                },
                type: 'time',
                time: {
                    unit: 'day',
                    displayFormats: {
                        hour: 'DD-MM-YYYY h:mm',
                        day: 'll',
                        week: 'll',
                    }
                }
            }],
        yAxes: [{
                scaleLabel: {
                    display: true,
                    labelString: ''
                },
                ticks: {
                // beginAtZero: true,
                },
            }],
    },
};
export default function MetricsGraphs(props) {
    var intl = useIntl();
    return React.createElement(TabContent, { activeTab: props.activeTab }, props.chartsData.map(function (datasets, index) {
        // @ts-ignore
        var chartOptions = structuredClone(CHART_OPTIONS_DEFAULT);
        chartOptions.scales.xAxes[0].time.unit = props.unit ? props.unit : 'day';
        chartOptions.scales.xAxes[0].scaleLabel.labelString = intl.formatMessage({ id: 'unit.datetime' });
        var unit = datasets[0].unit;
        if (unit) {
            chartOptions.scales.yAxes[0].scaleLabel.labelString = intl.formatMessage({ id: 'unit.' + unit });
        }
        else {
            chartOptions.scales.yAxes[0].scaleLabel.display = false;
        }
        return React.createElement(TabPane, { key: datasets[0].name + '_' + index, tabId: index },
            React.createElement(MetricsLineChart, { chartData: { datasets: datasets }, chartOptions: chartOptions, name: props.name }));
    }));
}
